export default function StrawberrySection() {
    const strawberryImages = [
        "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545057/WhatsApp_Image_2026-01-04_at_7.15.40_PM_1_fsnpil.jpg",
        "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545060/WhatsApp_Image_2026-01-04_at_7.15.42_PM_btaabt.jpg",
        "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545060/WhatsApp_Image_2026-01-04_at_7.15.41_PM_1_qntzzz.jpg",
        "https://res.cloudinary.com/dqlodrd4i/image/upload/v1767545588/WhatsApp_Image_2026-01-04_at_7.15.39_PM_zcik6r.jpg"
    ];

    return (
        <section className="py-5 bg-white border-top">
            <div className="container">
                <div className="text-center mx-auto mb-5" style={{ maxWidth: '800px' }}>
                    <span className="badge bg-green-lt mb-3 p-2">Seasonal Special</span>
                    <h2 className="display-4 fw-bold text-dark mb-4">
                        Strawberry <span className="text-primary">Pick & Eat</span>
                    </h2>
                    <p className="lead text-secondary mb-5">
                        Experience the joy of harvesting your own fresh, juicy strawberries right from our farm. 
                        A perfect winter delight for families and fruit lovers!
                    </p>
                    
                    <div className="d-flex flex-wrap justify-content-center gap-4 gap-md-5 mb-5">
                        <div className="d-flex align-items-center text-start">
                            <div className="bg-green-lt p-3 rounded-circle me-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-basket text-primary" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 10l5 -6l5 6" /><path d="M21 10l-2 8a2 1.25 0 0 1 -2 2h-10a2 1.25 0 0 1 -2 -2l-2 -8z" /><path d="M12 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /></svg>
                            </div>
                            <div>
                                <h4 className="h5 mb-1 text-dark">Fresh Picking</h4>
                                <p className="small text-secondary mb-0">Pick straight from the plant</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center text-start">
                            <div className="bg-green-lt p-3 rounded-circle me-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-package text-primary" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5" /><path d="M12 12l8 -4.5" /><path d="M12 12l0 9" /><path d="M12 12l-8 -4.5" /><path d="M16 5.25l-8 4.5" /></svg>
                            </div>
                            <div>
                                <h4 className="h5 mb-1 text-dark">Parcel Service</h4>
                                <p className="small text-secondary mb-0">Take the sweetness home</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="row row-cols-2 row-cols-md-4 g-3 mb-5">
                    {strawberryImages.map((img, index) => (
                        <div className="col" key={index}>
                            <div className="overflow-hidden rounded-4 shadow-sm ratio ratio-1x1">
                                <img src={img} alt={`Strawberry farm moment ${index + 1}`} className="object-fit-cover w-100 h-100" loading="lazy" />
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center">
                    <a href="/enquiry" className="btn btn-primary btn-lg px-4 rounded-pill">
                        Book Your Visit
                    </a>
                </div>
            </div>
        </section>
    );
}
